import { permissionsKeys } from '@/types/permissionsType';
import type { Node } from '@ui';
export const navigationMenuBar: Node[] = [
  {
    value: 'projects',
    label: 'Projects',
    action: '/projects',
    permission: [
      permissionsKeys.add_project,
      permissionsKeys.change_project,
      permissionsKeys.delete_project,
      permissionsKeys.view_project,
    ],
  },
  {
    value: 'releases',
    label: 'Releases',
    action: '/releases',
    permission: [
      permissionsKeys.add_release,
      permissionsKeys.change_release,
      permissionsKeys.delete_release,
      permissionsKeys.view_release,
    ],
  },
  {
    value: 'treeHeader-projectmanagement',
    label: 'Project Management',
    children: [
      {
        value: 'timesheet',
        label: 'Time Sheet',
        action: '/timesheet',
      },
      {
        value: 'rfisubmittals',
        label: 'RFI Submittals',
        action: '/rfisubmittals',
        permission: [
          // rfi log
          permissionsKeys.add_rfilog,
          permissionsKeys.change_rfilog,
          permissionsKeys.delete_rfilog,
          permissionsKeys.view_rfilog,

          // submittal
          permissionsKeys.add_submittal,
          permissionsKeys.change_submittal,
          permissionsKeys.delete_submittal,
          permissionsKeys.view_submittal,
        ],
      },
      {
        value: 'financials',
        label: 'Financials',
        action: '/financials',
        permission: [
          // reuse existing access for now since Change Orders currently lives inside RFI/Submittals
          permissionsKeys.add_rfilog,
          permissionsKeys.change_rfilog,
          permissionsKeys.delete_rfilog,
          permissionsKeys.view_rfilog,

          permissionsKeys.add_submittal,
          permissionsKeys.change_submittal,
          permissionsKeys.delete_submittal,
          permissionsKeys.view_submittal,

          // budget
          permissionsKeys.view_projectbudget,
          permissionsKeys.add_projectbudget,
          permissionsKeys.change_projectbudget,
          permissionsKeys.import_projectbudget,
          permissionsKeys.apply_changeorder_to_budget,
        ],
      },
    ],
  },
  {
    value: 'treeHeader-fabrication',
    label: 'Shop Fabrication',
    children: [
      {
        value: 'fabricationsummary',
        label: 'Fabrication Summary',
        action: '/fabrication-summary',
        permission: [
          permissionsKeys.view_fabricationpartconfig,
          permissionsKeys.change_fabricationpartconfig,
        ],
      },
      {
        value: 'fabricationworkorders',
        label: 'Fabrication Work Orders',
        action: '/fabrication-workorders',
        permission: [
          permissionsKeys.add_fabricationworkorder,
          permissionsKeys.change_fabricationworkorder,
          permissionsKeys.delete_fabricationworkorder,
          permissionsKeys.view_fabricationworkorder,
        ],
      },
      {
        value: 'fabricationworkers',
        label: 'Fabrication Operators',
        action: '/fabrication-workers',
        permission: [
          permissionsKeys.change_fabricationworkorder,
          permissionsKeys.view_fabricationworkorder,
        ],
      },
    ],
  },
  {
    value: 'treeHeader-frame-production',
    label: 'Frame Production',
    children: [
      {
        value: 'workorder',
        label: 'Frame Work Orders',
        action: '/workorder',
        permission: [
          permissionsKeys.add_workorder,
          permissionsKeys.change_workorder,
          permissionsKeys.delete_workorder,
          permissionsKeys.view_workorder,
        ],
      },
      {
        value: 'assembly',
        label: 'Assembly',
        action: '/assembly',
        permission: [
          permissionsKeys.change_workorder,
          permissionsKeys.view_workorder,
        ],
      },
      {
        value: 'glazing',
        label: 'Glazing',
        action: '/glazing',
        permission: [
          permissionsKeys.change_workorder,
          permissionsKeys.view_workorder,
        ],
      },
      {
        value: 'production-checklists',
        label: 'Checklist Settings',
        action: '/production-checklists',
        permission: [permissionsKeys.change_checklist],
      },
      {
        value: 'productionsummary',
        label: 'Frame Production Summary',
        action: '/productionsummary',
        permission: [permissionsKeys.view_release],
      },
    ],
  },
  {
    value: 'installation',
    label: 'Installation',
    action: '/installation',
    permission: [
      permissionsKeys.change_workorder,
      permissionsKeys.view_workorder,
    ],
  },
  {
    value: 'procurement',
    label: 'Purchase Orders',
    action: '/procurement',
    permission: [
      // supplier
      permissionsKeys.add_supplier,
      permissionsKeys.change_supplier,
      permissionsKeys.delete_supplier,
      permissionsKeys.view_supplier,

      // purchase order
      permissionsKeys.add_purchaseorder,
      permissionsKeys.change_purchaseorder,
      permissionsKeys.delete_purchaseorder,
      permissionsKeys.view_purchaseorder,
    ],
  },
  {
    value: 'treeHeader-inventory',
    label: 'Inventory',
    children: [
      {
        value: 'inventory',
        label: 'Inventory',
        action: '/inventory',
        permission: [
          permissionsKeys.add_inventory,
          permissionsKeys.change_inventory,
          permissionsKeys.delete_inventory,
          permissionsKeys.view_inventory,
        ],
      },
      {
        value: 'receiving',
        label: 'Receiving',
        action: '/receiving',
        tutorialId: 'receiving-navigation-link',
        permission: [permissionsKeys.view_inventory],
      },
      {
        value: 'site-delivery',
        label: 'Site Delivery',
        action: '/site-delivery',
        permission: [
          permissionsKeys.view_inventorydispatch,
          permissionsKeys.add_inventorydispatch,
          permissionsKeys.change_inventorydispatch,
          permissionsKeys.delete_inventorydispatch,
          permissionsKeys.post_inventorydispatch,
          permissionsKeys.void_inventorydispatch,
        ],
      },
      {
        value: 'packing',
        label: 'Packing',
        action: '/packing',
        permission: [
          permissionsKeys.add_packingslip,
          permissionsKeys.change_packingslip,
          permissionsKeys.delete_packingslip,
          permissionsKeys.view_packingslip,
        ],
      },
      {
        value: 'shipping',
        label: 'Shipping',
        action: '/shipping',
        permission: [
          permissionsKeys.add_shippinglist,
          permissionsKeys.change_shippinglist,
          permissionsKeys.delete_shippinglist,
          permissionsKeys.view_shippinglist,
        ],
      },
    ],
  },
  {
    value: 'qualitycontrol',
    label: 'Quality Control',
    action: '/qualitycontrol',
    permission: [
      permissionsKeys.add_qualityevent,
      permissionsKeys.change_qualityevent,
      permissionsKeys.delete_qualityevent,
      permissionsKeys.view_qualityevent,
    ],
  },
  {
    value: 'tracking',
    label: 'Tracking & Labels',
    action: '/tracking',
    permission: [permissionsKeys.view_trackeditem],
  },
  {
    value: 'analytics',
    label: 'Analytics',
    action: '/analytics',
  },
  {
    value: 'users',
    label: 'Users',
    action: '/users',
    permission: [
      // role
      permissionsKeys.add_user,
      permissionsKeys.change_user,
      permissionsKeys.delete_user,
      permissionsKeys.view_user,

      // user
      permissionsKeys.add_user,
      permissionsKeys.change_user,
      permissionsKeys.delete_user,
      permissionsKeys.view_user,
    ],
  },
  {
    value: 'masterfiles',
    label: 'Master Files',
    action: '/masterfiles',
  },
];
